import { makeStyles } from '@material-ui/core/styles';
import { DIMENSIONS } from '../../../styles/constants';

export const useStyles = makeStyles(theme => ({
	tableBar: {
		display: 'flex',
		alignItems: 'center',
		height: DIMENSIONS.SKELETON_TITLE_HEIGHT,
		padding: `${theme.spacing(1.5)}px ${theme.spacing(3)}px`
	},
	tableRow: {
		height: DIMENSIONS.SKELETON_TABLE_ROW_HEIGHT
	},
	skeleton: {
		margin: `0 ${theme.spacing(3)}px`
	}
}));
